import { Action, initialContextValue } from "../context/AppContext"
import { authConstants, moduleConstants } from "../context/constants"
import { ModuloPermiso } from "../types/admin-usuarios/ModuloPermiso"

export const moduleReducer = (state: ModuloPermiso|undefined, action: Action) => {
    try {
        switch (action.type) {
            case moduleConstants.SAVE_MODULE:
                return { 
                    ...action.payload,
                    loaded: true
                }
            case moduleConstants.MODULE_FAILURE:
            case authConstants.LOGOUT:
                return {
                    module: undefined,
                    loaded: true
                }
            default:
                return state;
        }
    } catch (err) {
        localStorage.removeItem("persist");
        return initialContextValue;
    }
}